// export const BASE_URL = "https://tinwork-urology-preacher.ngrok-free.dev/api/v1"
// export const BASE_URL = "https://uncaptivating-anaphylactically-elise.ngrok-free.dev/api/v1"
export const BASE_URL ="https://api.hireceleb.com/api/v1" 



export const STATUS_CODE = {
  INTERNAL_SERVER_ERROR: 500,
  SUCCESS: 200,
};

